import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { styled } from '@xstyled/styled-components';
import { Button, Input, Tooltip } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledInput = styled(Input)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 84% !important;\n  background-color: inherit !important;\n  color: ", " !important;\n"])), styleVariables.colors.gray13);
var StyledButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 16%;\n"])));
var StyledCopyOutlined = styled(CopyOutlined)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), styleVariables.colors.blue4);
var StyledCheckCircleOutlined = styled(CheckOutlined)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 600;\n"])), styleVariables.colors.green1);
export var DefaultCopyBox = function DefaultCopyBox(_ref) {
  var text = _ref.text,
      copyBoxTranslation = _ref.copyBoxTranslation;

  var _useState = useState(),
      timerId = _useState[0],
      setTimerId = _useState[1];

  var _useState2 = useState(false),
      isCopied = _useState2[0],
      setIsCopied = _useState2[1];

  var handleCopyText = useCallback(function (e) {
    e.preventDefault();

    if (timerId) {
      clearTimeout(timerId);
    }

    navigator.clipboard.writeText(text);
    setIsCopied(true);
    var timer = setTimeout(function () {
      return setIsCopied(false);
    }, 2000);
    setTimerId(function () {
      return timer;
    });
  }, []);
  useEffect(function () {
    return function () {
      return setIsCopied(false);
    };
  }, []);
  return /*#__PURE__*/_jsxs(Input.Group, {
    compact: true,
    children: [/*#__PURE__*/_jsx(StyledInput, {
      value: text,
      disabled: true,
      size: "large"
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: !isCopied ? copyBoxTranslation.copy : copyBoxTranslation.copied,
      children: /*#__PURE__*/_jsx(StyledButton, {
        size: "large",
        onClick: handleCopyText,
        children: !isCopied ? /*#__PURE__*/_jsx(StyledCopyOutlined, {}) : /*#__PURE__*/_jsx(StyledCheckCircleOutlined, {})
      })
    })]
  });
};